import {BaseApi, RequireAuthApi} from '@/api/base.api';
import {TimelineModel} from '@/models/timeline.model';

export class TimelineApi extends BaseApi<TimelineModel> {
  constructor(protected challengeId: number) {
    super(`challenges/${challengeId}/timelines`, [
      RequireAuthApi.DESTROY,
      RequireAuthApi.UPDATE,
      RequireAuthApi.CREATE,
    ]);
  }
}
